import React from 'react';
import {
  Avatar,
  Box,
  COLORS,
  Flex,
  Icon,
  IconButton,
  Indicator,
  Menu,
  Spacer,
  TabList,
  Tabs,
  Text,
} from '@podiumhq/design-system';

const FakeNavBar = () => {
  return (
    <Box
      minWidth="864px"
      backgroundColor={COLORS.black.base}
      color={COLORS.black.lightest}
      minHeight="56px"
      padding="0px 8px"
      display="flex"
      alignItems="center"
      width="100%"
      justifyContent="space-between"
    >
      <Flex justifyContent="flex-center" alignItems="center">
        <Icon boxSize="24px" margin="0 1.25em 0 1em" type="Logo" />{' '}
        <Tabs alignItems="center" display="flex" height="3.5rem">
          <TabList
            alignItems="center"
            display="flex"
            borderColor="transparent"
            gridGap={2}
            height="100%"
          >
            <Box
              height="3.5rem"
              padding="0"
              display="flex"
              alignItems="center"
              marginBottom="0"
            >
              <Text
                padding="1rem"
                fontSize="md"
                marginTop="4px"
                fontWeight="semibold"
                display="flex"
                alignItems="center"
                color="silver.lightest"
                borderBottom="4px solid"
                borderBottomColor="blue.base"
              >
                Inbox
              </Text>
              <Indicator
                color="red"
                left="7.7rem"
                top="16px"
                marginBottom=".8rem"
                position="absolute"
                size="md"
              />
            </Box>
            <Box
              height="3.5rem"
              padding="0"
              display="flex"
              alignItems="center"
              marginBottom="0"
              tabIndex="-1"
            >
              <Text
                padding="1rem"
                fontSize="md"
                fontWeight="semibold"
                display="flex"
                alignItems="center"
              >
                Contacts
              </Text>
            </Box>
            <Box
              height="3.5rem"
              padding="0"
              display="flex"
              alignItems="center"
              marginBottom="0"
              tabIndex="-1"
            >
              <Menu
                isActive={false}
                gutter={9}
                variant="unstyled"
                height="100%"
                padding="0 .75rem"
                _focusVisible={{
                  boxShadow: `0px 0px 0px 4px ${COLORS.blue.lighter}`,
                }}
                id="navigation-marketing-menu"
                tabIndex="-1"
              >
                <Text
                  fontSize="md"
                  fontWeight="semibold"
                  display="flex"
                  alignItems="center"
                >
                  Marketing
                  <Icon
                    type="Chevron"
                    marginLeft="4px"
                    marginTop="2px"
                    boxSize="4"
                  />
                </Text>
              </Menu>
            </Box>
          </TabList>
        </Tabs>
      </Flex>
      <Spacer />
      <Flex alignItems="center" h="inherit" justifyContent="center">
        <Flex>
          <Menu fontWeight="medium" gutter={12}>
            <IconButton
              fillColor="silver.lightest"
              size="sm"
              variant="ghost"
              margin="0 0 0 8px"
              iconSize="24px"
              type="QuestionMark"
              tabIndex="-1"
            />
          </Menu>
        </Flex>
        <Flex>
          <Menu gutter={12}>
            <IconButton
              color="silver.lightest"
              fillColor="silver.lightest"
              iconSize="24px"
              type="GearSettings"
              variant="ghost"
              margin="0 8px"
              size="sm"
              tabIndex="-1"
            />
          </Menu>
        </Flex>
      </Flex>
      <Box>
        <Avatar size="lg" margin="0 12px 0 8px" />
      </Box>
    </Box>
  );
};

export default FakeNavBar;
